const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';
const ROOTS_HOME = '/home';
const ROOTS_ONBOARDING = '/onboarding';
const ROOTS_REGISTER = '/register';

export const PATH_AUTH_SPA = {
  ROOT: ROOTS_AUTH,
};

export const PATH_REGISTER = {
  ROOT: ROOTS_REGISTER,
  SIGN_UP: `/sign-up`,
  EMAIL: `/sign-up-email`,
  GOOGLE: `/sign-up-google`,
};

export const PATH_PASSWORD_RESET = {
  ROOT: '/reset-password',
};

export const PATH_HOME = {
  ROOT: `${ROOTS_DASHBOARD}${ROOTS_HOME}`,
};

export const PATH_ONBOARDING = {
  ROOT: ROOTS_ONBOARDING,
};

export const PATH_DASHBOARD = {
  ROOT: ROOTS_DASHBOARD,
  PROJECTS: `${ROOTS_DASHBOARD}/projects`,
  PROJECTS_NEW: `${ROOTS_DASHBOARD}/projects/new`,
  PROJECTS_NEW_STEP_1: `${ROOTS_DASHBOARD}/projects/new/1`,
  PROJECTS_NEW_STEP_2: `${ROOTS_DASHBOARD}/projects/new/2`,
  PROJECTS_NEW_STEP_3: `${ROOTS_DASHBOARD}/projects/new/3`,
  PROJECTS_NEW_STEP_4: `${ROOTS_DASHBOARD}/projects/new/4`,
  ACCOUNT: `${ROOTS_DASHBOARD}/account`,
  SUBSCRIPTION: `${ROOTS_DASHBOARD}/subscription`,
  ANALYTICS: `${ROOTS_DASHBOARD}/analytics`,
  AI_KNOWLEDGE_BASE: `${ROOTS_DASHBOARD}/ai-knowledge-base`,
};
